import { useTranslation } from 'react-i18next';

import photoImg from '../../assets/photo.png';
import { Container, Content } from './styles';

export function Bio() {
  const { t } = useTranslation();

  return (
    <>
      <Container id="bio">
        <Content>
          <div id="aboutMe">
            <p>{t('hi')} 👋,</p>

            <p>
              {t('myName')} <br />
              <h1> Gabriel Camargo </h1>
              {t('buildForWeb')}
            </p>
          </div>

          <div className='photoCover'>
            <img src={photoImg} alt="imagem: Gabriel Camargo" />
          </div>
        </Content>
      </Container>
    </>
  )
}